import { Component, OnInit, } from '@angular/core';
import { environment } from '../../environments/environment';
import { serviceURLService } from '../service/serviceURL';
import { ActivatedRoute } from '@angular/router';
import { ChartData, ChartOptions, ChartType } from 'chart.js';
import { ExcelService } from '../services/excel.service';
import { Router } from '@angular/router';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import * as $ from 'jquery';
declare var $: any;


@Component({
  selector: 'app-your-policy-details',
  templateUrl: './your-policy-details.component.html',
  styleUrls: ['./your-policy-details.component.css']
})
export class YourPolicyDetailsComponent implements OnInit {
  policyPart: boolean = true;
  editPolicyPart: boolean = false;
  renewPolicyPart: boolean = false;
  claimPart: boolean = false;
  data: any = {};
  error: any;
  policy: any;
  cardNumber: string;
  policyType: string;
  policyHolder: string;
  gender: string;
  relation: string;
  sumInsured: string;
  company: string;
  email: string;
  insurerLogo:any;
  mobile: string;
  employeeId: string;
  policyNumber: string;
  insurer: string;
  insurerCode:String;
  maternity: string;
  roomRent: string;
  policyName: string;
  policyNumberdata: any = {};
  insurerLogoDetails: Array<any> = [];
  emailEditOrRenewResponse: Array<any> = [];
  ailment: string;
  diseaseList: any = ["Accelerated Hypertention", "ACL tear", "Acute Gastro entritis", "Anal Fissure",
    "Appendix", "Bronchitis", "CA Breast", "Carcinoma of any part", "Cataract", "Cerebrovascular attack", "CHOLELITHIASIS", "Chronic Kidney Disease", "Coronary Artery Disease", "CSOM",
    "Dengue", "Deviated Nasal Septum", "Diabetes Malitus", "Enteric Fever", "Fever", "Fibroid Uterus", "Fracture", "Hemorrhoids", "Inguinal Hernia", "Ischemic heart disease", "Lower Respiratory tracT Infection",
    "Malaria", "Mayocardial Infarction", "Osteoarthritis", "Other", "PIVD", "Pneumonitis", "Maternity/Pregnancy/Delivery", "Renal Stone",
    "Road traffic accident", "Seizure disorder", "Tonsilittis", "TRANSIENT ISCHAMIC ATTACK", "Tuberclosis", "Umblical Hernia", "Upper Respiratory tracT infection", "Urinary Tract Infection", "Viral Fever"]
  hospitalName: any;
  hospitalCity: any;
  hospitalState: any;
  estimatedAmount: any;
  employeeName: any;
  errorMessage: string;
  intimateSuccessfull: boolean = false;
  intimateFailure: boolean = false;
  registrationNumber: string;
  regDate: any;
  dischargeDate: any;
  startDate: any;
  endDate: any;
  policyCopyFileName: any;
  policyCopyFile: any;
  tpa: string;
  claimToDate: any;
  premiumPaid: any;
  loading: boolean;
  policyEditdata: any;
  policyRenewdata: any;
  selectedComment: any;
  editMailSentSuccessfull: boolean = false;
  renewMailSentSuccessfull: boolean = false;
  policyCopyUrl: any;
  clientProductDetailId: any;
  claimsInfo:any = {};
  appCount:any;
  isCorporateEB: boolean = false;
  endorsmentData: any = {};
  ebID:any;
  clientId:any;
  insurerId:any;
  eclaimsListdata:any =[];
  eClaimsListObj:any={};
  eClaimData:any;
  cdLedgerListdata:any =[];
  cdLedgerListObj:any={};
  cdLedgerData:any;
  appDownloadListData:any=[];
  appDownloadobj:any={};
  appDownloadData:any;
  cdNameId:any;
  paymentType:any;
  policyCoverType:string;
  familyDefinition:string;
  converstaionarr:any=[];
  holdData:any={};
  productId:String=''
  isManagerialLogin:boolean=false;
  policyUniqueId: string = '';
  selfPolicyAttachment : any;
  private onDestroy$: Subject<void> = new Subject<void>();
  
// Doughnut
ischartData : boolean = false
public doughnutChartType: ChartType = 'doughnut';
public doughnutChartData: ChartData<'doughnut', number[], string> = {
    labels: ['Employee', 'Spouse', 'Child', 'Parents'],
    datasets: [
      {
        data: [],
        backgroundColor: ['#ff9d00', '#16cabd', '#7a3cd8', '#d80706'],
        hoverOffset: 6 // optional nice effect
      }
    ]
  };

  public doughnutChartOptions: ChartOptions<'doughnut'> = {
    responsive: true,
    maintainAspectRatio: false, // helpful to control container sizing
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          // Chart.js v4 changed font options -> use font.size
          font: {
            size: 11
          },
          padding: 20,
          usePointStyle: true
        }
      },
      title: {
        display: false
      },
      tooltip: {
        enabled: true
      }
    }
  };

  constructor(private serviceURLService: serviceURLService, private activatedRoute: ActivatedRoute, private excelService:ExcelService,private router: Router) { 
    this.activatedRoute.queryParams.subscribe(params => {
      this.isCorporateEB = params['eb'];
   });
  }

  ngOnInit() {
    this.getInsurerLogo();
  }

  exportEclaims():void {
    var  value =  this.policyNumber
  
    this.serviceURLService.getEclaims(value).subscribe((successData: any) => {
      this.eClaimData = successData.data;
      for(let i=0; i<this.eClaimData.length; i++){
        this.eClaimsListObj={}
        this.eClaimsListObj.Sr_No = i+1
        this.eClaimsListObj.Intimation_No= this.eClaimData[i].intimationNo 
        this.eClaimsListObj.Ticket_Number= this.eClaimData[i].ticketNumber 
        this.eClaimsListObj.Corporate_Name= this.eClaimData[i].corporateName 
        this.eClaimsListObj.Insurer= this.eClaimData[i].insurer 
        this.eClaimsListObj.Policy_Number= this.eClaimData[i].policyNumber 
        this.eClaimsListObj.TPA = this.eClaimData[i].tpaName
        this.eClaimsListObj.Card_Number= this.eClaimData[i].cardNumber 
        this.eClaimsListObj.Product_Type= this.eClaimData[i].productType 
        this.eClaimsListObj.Record_Entered_By= this.eClaimData[i].recordEnteredBy 
        this.eClaimsListObj.Claim_Team_Member= this.eClaimData[i].claimTeamMember 
        this.eClaimsListObj.RM_Name= this.eClaimData[i].rm 
        this.eClaimsListObj.Employee_Name= this.eClaimData[i].employeeName 
        this.eClaimsListObj.Patient_Name= this.eClaimData[i].claimant 
        this.eClaimsListObj.Relation_With_Employee= this.eClaimData[i].relationWithEmployee 
        this.eClaimsListObj.Mobile_Number= this.eClaimData[i].mobileNo 
        this.eClaimsListObj.Email= this.eClaimData[i].email 
        this.eClaimsListObj.Hospital_Name= this.eClaimData[i].hospitalName 
        this.eClaimsListObj.Hospital_City= this.eClaimData[i].hospitalCity 
        this.eClaimsListObj.Hospital_State= this.eClaimData[i].hospitalState 
        this.eClaimsListObj.Claim_Source= this.eClaimData[i].claimSource 
        this.eClaimsListObj.Ailment= this.eClaimData[i].ailment 
        this.eClaimsListObj.Admission_Date= this.eClaimData[i].admissionDate 
        this.eClaimsListObj.Discharge_Date= this.eClaimData[i].dischargeDate 
        this.eClaimsListObj.Intimation_Date= this.eClaimData[i].dateCreated?this.eClaimData[i].dateCreated.split('T')[0] :''
        this.eClaimsListObj.Estimated_Amount= this.eClaimData[i].estimatedAmount 
        this.eClaimsListObj.First_submission_date = this.eClaimData[i].firstSubmissionDate?this.eClaimData[i].firstSubmissionDate.split('T')[0] :''
        this.eClaimsListObj.Claim_Registration_Date = this.eClaimData[i].claimRegistationDate 
        this.eClaimsListObj.File_Sent_Date_Hard_Copy= this.eClaimData[i].fileSentDate?this.eClaimData[i].fileSentDate.split('T')[0]:''
        this.eClaimsListObj.Registration_Remark= this.eClaimData[i].registrationRemarks 
        this.eClaimsListObj.Claim_No_by_Insurer= this.eClaimData[i].claimNoByInsurer 
        this.eClaimsListObj.Query= this.eClaimData[i].subStatus 
        this.eClaimsListObj.Deficiency_Received_DATE_from_Insurer =this.eClaimData[i].deficiencyReceivedDate?this.eClaimData[i].deficiencyReceivedDate.split('T')[0] :''
        this.eClaimsListObj.Deficiency_Sent_Date_to_Insurer =this.eClaimData[i].deficiencySentDate? this.eClaimData[i].deficiencySentDate.split('T')[0] :''
        this.eClaimsListObj.Last_submission_date = this.eClaimData[i].lastSubmissionDate?this.eClaimData[i].lastSubmissionDate.split('T')[0] :''
        this.eClaimsListObj.Claim_Stage= this.eClaimData[i].claimStage 
        this.eClaimsListObj.Status= this.eClaimData[i].status 
        this.eClaimsListObj.Status_Remarks = this.eClaimData[i].comment 
        this.eClaimsListObj.Last_Updated= this.eClaimData[i].lastUpdated?this.eClaimData[i].lastUpdated.split('T')[0]:'' 
        this.eClaimsListObj.Claimed_Amount= this.eClaimData[i].claimedAmount 
        this.eClaimsListObj.Approved_Amount= this.eClaimData[i].approvedAmount 
        this.eClaimsListObj.Deduction_Amount= this.eClaimData[i].deductionAmount 
        this.eClaimsListObj.Reason= this.eClaimData[i].reason 
        this.eClaimsListObj.Registration_Remark= this.eClaimData[i].registrationRemarks 
        this.eClaimsListObj.Ticket_Number= this.eClaimData[i].ticketNumber 
        this.eClaimsListObj.RM_Name= this.eClaimData[i].rm 
        this.eClaimsListObj.File_Sent_Date_Hard_Copy= this.eClaimData[i].fileSentDate?this.eClaimData[i].fileSentDate.split('T')[0]:''
        this.eClaimsListObj.Claimed_Amount= this.eClaimData[i].claimedAmount 
        this.eClaimsListObj.Claim_Registration_Date = this.eClaimData[i].claimRegistationDate 
        this.eClaimsListObj.Deficiency_Received_DATE_from_Insurer =this.eClaimData[i].deficiencyReceivedDate?this.eClaimData[i].deficiencyReceivedDate.split('T')[0] :''
        this.eClaimsListObj.Deficiency_Sent_Date_to_Insurer =this.eClaimData[i].deficiencySentDate? this.eClaimData[i].deficiencySentDate.split('T')[0] :''
        this.eClaimsListObj.Claim_Approval_Date = this.eClaimData[i].claimApprovalDate?this.eClaimData[i].claimApprovalDate.split('T')[0] :''
        this.eClaimsListObj.Settlement_Date =this.eClaimData[i].settlementDate?this.eClaimData[i].settlementDate.split('T')[0] :''
        this.eClaimsListObj.First_submission_date = this.eClaimData[i].firstSubmissionDate?this.eClaimData[i].firstSubmissionDate.split('T')[0] :''
        this.eClaimsListObj.Last_submission_date = this.eClaimData[i].lastSubmissionDate?this.eClaimData[i].lastSubmissionDate.split('T')[0] :''
        this.eClaimsListObj.TPA = this.eClaimData[i].tpaName
        this.eClaimsListObj.Record_Entered_By= this.eClaimData[i].recordEnteredBy 
        this.eclaimsListdata.push(this.eClaimsListObj)
             }
  
     console.log(this.eclaimsListdata)
     this.excelService.exportAsExcelFile(this.eclaimsListdata, 'Eclaims_Export_data');
    }, errorData => {
      this.error = errorData;
      console.log("no data");
    });
    
  }

  exportAppDownload():void {
    
  
    this.serviceURLService.getAppDownloads(this.mobile,this.policyUniqueId).subscribe((successData: any) => {
      this.appDownloadData = successData.message;
      for(let i=0; i<  this.appDownloadData.length; i++){
        this.appDownloadobj={}
        this.appDownloadobj.SR_No = i+1
        this.appDownloadobj.Name =this.appDownloadData[i].name  
        this.appDownloadobj.Mobile =this.appDownloadData[i].mobile  
        this.appDownloadobj.Email =this.appDownloadData[i].email    
        this.appDownloadListData.push(this.appDownloadobj)
      }
     
  
     console.log(this.eclaimsListdata)
     this.excelService.exportAsExcelFile(this.appDownloadListData, 'App_Download_Count_Export_data');
    }, errorData => {
      this.error = errorData;
      console.log("no data");
    });
    
  }

  misPdfDownload(){
    console.log("hello pdf");
    var url = environment.pam2Url  + "/pam/api/v1/notify/get-claim-mis-report-PDF?policyNumber=" + this.policyNumber
    window.open(url)
  }


  exportCDLedger():void {
 
    var clientid =  this.clientId
    var insurerId =    this.insurerId
  
    this.serviceURLService.getCDledger(clientid, insurerId, this.cdNameId).subscribe((successData: any) => {
      this.cdLedgerData = successData.data;
      for(let i=0; i<  this.cdLedgerData.length; i++){
        this.cdLedgerListObj={}
        this.cdLedgerListObj.SR_No = i+1
        this.cdLedgerListObj.Data_Entry_Date =   this.cdLedgerData[i].dateCreated?this.cdLedgerData[i].dateCreated.split("T")[0]:''
        this.cdLedgerListObj.Insurer_CD_Ledger_Date =this.cdLedgerData[i].insurerCdLedgerDate?this.cdLedgerData[i].insurerCdLedgerDate.split("T")[0]:''
        this.cdLedgerListObj.Endorsement_No = this.cdLedgerData[i].endorsementNumber 
        this.cdLedgerListObj.Policy_Holder =this.cdLedgerData[i].clientName 
        this.cdLedgerListObj.Product =this.cdLedgerData[i].productName 
        this.cdLedgerListObj.Type_of_Transaction =this.cdLedgerData[i].typeOfTransaction  
        this.cdLedgerListObj.Transaction_Amount =this.cdLedgerData[i].transactionAmount 
        this.cdLedgerListObj.Tax =this.cdLedgerData[i].transactionAmountTax  
        this.cdLedgerListObj.Closing_Balance =this.cdLedgerData[i].balance    
        this.cdLedgerListdata.push(this.cdLedgerListObj)
      }
  
     console.log(this.eclaimsListdata)
     this.excelService.exportAsExcelFile(this.cdLedgerListdata, 'CD_Ledger_Export_data');
    }, errorData => {
      this.error = errorData;
      console.log("no data");
    });
    
  }
 




  getPolicyByPolicyNumber() {
    this.loading = true;
    // this.policyNumber = localStorage.getItem("policyId");
    var policyId = localStorage.getItem("policyId");
    this.policyUniqueId = policyId;
    var policyNumber = localStorage.getItem("policyNumber")
   // this.policyHolder = localStorage.getItem("name");
    var policyPlatform = localStorage.getItem("policyPlatform");

    if(policyPlatform == 'pamPolicy') {
      this.getPamPolicy(policyId);
    }
    else if(policyPlatform == 'Individual' || policyPlatform == 'NonEB'){
      this.getPersonalandNonEBPolicy(policyId)
    }
    else {
      this.getOtherPolicy(policyId, policyPlatform);
    }
    if(this.isCorporateEB) {

    }
  }

  getPamPolicy(policyId) {
    console.log(policyId)
    this.serviceURLService.getPolicybyPolicyID(policyId).subscribe((successData: any) => {
      this.policy = successData.data;
      this.loading = false;
      this.policyNumber = this.policy.policyNumber ? this.policy.policyNumber: 'NA';
      this.policyType = this.policy.policy ? this.policy.policy: 'NA';
      this.sumInsured = this.policy.sumAssured ;
      this.email = this.policy.email ? this.policy.email: 'NA';
      this.mobile = this.policy.mobile ? this.policy.mobile: 'NA';
      this.ebID = this.policy.id?this.policy.id:'NA';
      this.policyHolder = this.policy.policyHolder?this.policy.policyHolder:'NA';
      this.premiumPaid = this.policy.premium ? this.policy.premium: 'NA';
      this.insurer = this.policy.insurer ? this.policy.insurer: 'NA';
      this.policyName = this.policy.policyName ? this.policy.policyName: 'NA';
      this.startDate = this.policy.startDate ? this.policy.startDate: 'NA';
      this.endDate = this.policy.endDate ? this.policy.endDate: 'NA';
      this.policyCopyFileName = this.policy.policyCopyFileName;
      this.policyCopyFile = this.policy.policyCopyFile ? this.policy.policyCopyFile: 'NA';
      this.clientProductDetailId = this.policy.id;
      this.policyCopyUrl = environment.pam2Url +'/admin/api/v1/admin-base-policy/downloadFile?cpdId=' + this.clientProductDetailId + '&type=policyCopyFile'+'&fileName='+encodeURIComponent(this.policyCopyFileName);
      this.insurerLogo = this.policy.insurerLogo;
      this.cdNameId = this.policy.cdNameId;
      this.paymentType = this.policy.paymentType;
      this.policyCoverType = this.policy.policyCoverType;
      this.familyDefinition = this.policy.familyDefinition;
      this.insurerCode = this.policy.insurerCode;
      this.productId=this.policy.productId
      this.checkManegerialLogin(this.mobile,this.policyHolder);
      // }
      this.getTPA();
    
      this.getEndorsmentDetails(this.ebID);
      this.getAppDownloadCount();
      if( this.policyName !=='Workmen Compensation'){
      this.getClaimsInfo(this.policyNumber);
      this.getMisChartData(this.policyNumber);
      }
    }, errorData => {
      this.loading = false;
    });
  }


  getClaimsInfo(policyNumber) {
    this.serviceURLService.getClaimsInfo(policyNumber).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.claimsInfo = successData.data;
    }, errorData => {
    })
  }

  getMisChartData(policyNumber: string) {
    this.serviceURLService.getMisChartData(policyNumber)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (successData: any) => {
          // 🧩 Instead of pushing, we replace the whole array
          const newData = [
            successData.data.employee || 0,
            successData.data.spouse || 0,
            successData.data.child || 0,
            successData.data.parent || 0
          ];
          if(newData[0] == 0 && newData[1] == 0 && newData[2] == 0 && newData[3] == 0){
            this.ischartData = true
          }

          // ✅ Create a new object reference to trigger change detection
          this.doughnutChartData = {
            ...this.doughnutChartData,
            datasets: [
              {
                ...this.doughnutChartData.datasets[0],
                data: newData
              }
            ]
          };

          console.log('Updated chart data:', this.doughnutChartData);
        },
        error: (errorData) => {
          console.error('Error fetching chart data', errorData);
        }
      });
  }

  getTPA(){
  
   this.serviceURLService.getTPA(this.policyNumber).subscribe((successData: any) => {
    this.tpa =  successData.data.tpaName;
   }, errorData => {
   })
  }

  getEndorsmentDetails(ebID) {
    var  PoliciesData 
     PoliciesData = localStorage.getItem('PamPoliciesData');
     PoliciesData = JSON.parse(PoliciesData)
     this.loading=true
    for(var i=0; i<PoliciesData.length; i++){
      if(PoliciesData[i].id==ebID) {
          this.clientId = PoliciesData[i].clientId
          this.insurerId = PoliciesData[i].insurerId
          console.log( this.clientId, this.insurerId)

          //$scope.apply();
      }
  }

    this.serviceURLService.getEndorsmentData(this.clientId, this.insurerId, this.cdNameId).subscribe((successData: any) => {
      this.endorsmentData =  successData.data[successData.data.length-1];
      this.loading=false
    }, errorData => {
      this.loading = false;
    })

    this.serviceURLService.getHoldCdBalance(this.clientId,this.insurerId,this.cdNameId,this.productId).subscribe((successData: any) =>{
      this.holdData = successData.data;

    }, errorData => {
       this.loading=false
     });
  }

  getAppDownloadCount() {
    this.serviceURLService.getAppDownloads(this.mobile,this.policyUniqueId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
        this.appCount =  successData.response;
    }, errorData => {
    })
  }

  getOtherPolicy(policyId, policyPlatform) {
    this.serviceURLService.getPolicyDetails(policyId, policyPlatform).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.policy = successData.response;
      this.loading = false;
      for (var i = 0; i < this.policy.length; i++) {
        console.log(this.policy.length);
        this.policyNumber = this.policy[0].policyNo ? this.policy[0].policyNo: this.policy[0].policyNumber;
        this.policyType = this.policy[0].policy;
        this.sumInsured = this.policy[0].sumInsured;
        // this.company = this.policy[i].companyName;
        this.email = this.policy[0].email;
        this.mobile = this.policy[0].phoneNumber;
        this.premiumPaid = this.policy[0].premiumPaid ? this.policy[0].premiumPaid: 'NA';
        this.insurer = this.policy[0].Insurer;
        // this.maternity = this.policy[i].Maternity;
        // this.roomRent = this.policy[i].roomRent;
        this.policyName = this.policy[0].policyName;
        this.startDate = this.policy[0].policyStartDate;
        this.endDate = this.policy[0].policyEndDate;
        this.tpa = this.policy[0].tpa_code;
        this.claimToDate = this.policy[0].claimToDate;
        this.policyHolder = this.policy[0].policyHolder
        this.productId = this.policy[0].productId
        this.selfPolicyAttachment = this.policy[0].attachment
        for(let j=0; j<this.insurerLogoDetails.length; j++) {
          if(this.policy[0].insurerCode.toLowerCase() === this.insurerLogoDetails[j].code.toLowerCase()) {
            this.insurerLogo = this.insurerLogoDetails[j].insurerLogo;
            break;
          }
        }
      }
      //this.getInsurerLogo();
      //this.getEndorsmentDetails();
     // this.getAppDownloadCount();
      // this.loading = false;
      this.checkManegerialLogin(this.mobile,this.policyHolder);
    }, errorData => {
      this.error = errorData;
      console.log("no data");
    })
  }

  getPersonalandNonEBPolicy(policyId){

    this.serviceURLService.getPolicybyPolicyID(policyId).subscribe((successData: any) => {
      this.policy = successData.data;
      this.loading = false;
      this.policyHolder = this.policy.policyHolder?this.policy.policyHolder:'NA';
      this.policyNumber = this.policy.policyNumber ? this.policy.policyNumber: 'NA';
      this.policyType = this.policy.policy ? this.policy.policy: 'NA';
      this.sumInsured = this.policy.sumAssured ;
      this.email = this.policy.email ? this.policy.email: 'NA';
      this.mobile = this.policy.mobile ? this.policy.mobile: 'NA';
      this.premiumPaid = this.policy.premium ? this.policy.premium: 'NA';
      this.insurer = this.policy.insurer ? this.policy.insurer: 'NA';
      this.policyName = this.policy.policyName ? this.policy.policyName: 'NA';
      this.startDate = this.policy.startDate ? this.policy.startDate: 'NA';
      this.endDate = this.policy.endDate ? this.policy.endDate: 'NA';
      this.policyCopyFileName = this.policy.policyCopyFileName;
      this.policyCopyFile = this.policy.policyCopyFile ? this.policy.policyCopyFile: 'NA';
      this.clientProductDetailId = this.policy.id;
      this.policyCopyUrl = environment.pam2Url +'/admin/api/v1/admin-base-policy/downloadFile?cpdId=' + this.clientProductDetailId + '&type=policyCopyFile'+'&fileName='+encodeURIComponent(this.policyCopyFileName);
      this.insurerLogo = this.policy.insurerLogo;
      this.productId=this.policy.productId
    
      this.checkManegerialLogin(this.mobile,this.policyHolder);
    }, errorData => {
      this.error = errorData;
      console.log("no data");
    });
  
  }

  getInsurerLogo() {
    // this.loading = true;
    this.policyNumberdata =
    {
      policyNumber: [this.policyNumber]
    };
    this.serviceURLService.getInsurerLogo().pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.insurerLogoDetails = successData.data.insurerDtos;
      // this.loading = false;
      this.getPolicyByPolicyNumber();
    }, errorData => {
      this.error = errorData;
      console.log("no data");
      this.getPolicyByPolicyNumber();
    });
  }

  closeChatConversation(){
    $("#conversationModal").modal("hide");
      //console.log("m here1")
      this.converstaionarr = []
  }

  showChatConversation(){
    this.loading = true;
    $("#conversationModal").modal("show");
  
    var myHeaders = new Headers();
     myHeaders.append("Authorization", "Basic UDZyNUIwQ1BEdWMxN3BQUThMVFE6eA==");
    myHeaders.append("Content-Type", "application/json");
  
   
    fetch("https://securein.freshdesk.com/api/v2/tickets?email="+this.email, {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    })
      .then(response => response.text())
      .then((result) => {
         console.log(JSON.parse(result))
         let data = JSON.parse(result)
         var ticketIdarr = []
         for(var i=0; i<data.length; i++){
             ticketIdarr.push(data[i].id)
         }
         console.log(ticketIdarr, "tickets")
         //var converstaionarr = []
         for(var y=0; y<ticketIdarr.length; y++){
           fetch('https://securein.freshdesk.com/api/v2/tickets/'+ticketIdarr[y]+'?include=conversations', {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow',
          })
            .then(response => response.text())
            .then((result) => {
               
               let data1 = JSON.parse(result)
               var messageArr = []
               for(var p=0; p<data1.conversations.length; p++) {
                   var msg = data1.conversations[p].body
                    messageArr.push(msg)
                  }
                  var conversation = {
                      "subject": data1.subject,
                      "sentDate": data1.updated_at,
                      "mailContent":  messageArr
                  }
                  this.converstaionarr.push(conversation) 
                  console.log(this.converstaionarr,"fhdjhfdjhf")
                  this.loading=false
            }).catch(error => {
              console.log('error', error)
              this.loading=false
            });
         }
      })
      .catch(error => {
        console.log('error', error)
        this.loading = false;
      });
        this.converstaionarr = []
       
    
  }

  formatDateToYMD(date: any): string {
    if (date === undefined || date === null || date === '') {
      return '';
    }
    if (typeof date === 'number' || /^\d+$/.test(String(date))) {
      const parsed = new Date(Number(date));
      return isNaN(parsed.getTime()) ? String(date) : parsed.toISOString().split("T")[0];
    }
    if (typeof date === 'string') {
      return date.split("T")[0];
    }
    if (date instanceof Date) {
      return date.toISOString().split("T")[0];
    }
    return date;
  }

  submitEditOrRenewRequest(requestType) {
    this.loading = true;
    this.policyEditdata =
    {
      policyNumber: this.policyNumber,
      productName: this.policyName,
      policyEndDate: this.formatDateToYMD(this.endDate),
      email: localStorage.getItem("email"),
      policyHolder: localStorage.getItem("name"),
      comment: this.selectedComment,
      requestType: requestType
    };
    this.serviceURLService.submitPolicyEditOrRenewRequest(this.policyEditdata).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.emailEditOrRenewResponse = JSON.parse(successData.data);
      this.loading = false;
      // JSON.stringify(this.emailEditOrRenewResponse);
      console.log(this.emailEditOrRenewResponse);
      if(requestType == "Renew"){
        console.log(requestType);
        this.renewMailSentSuccessfull = true;
        this.editMailSentSuccessfull = false;
      } else if(requestType == "Edit") {
        this.editMailSentSuccessfull = true;
        this.renewMailSentSuccessfull = false;
      }
      
    }, errorData => {
      this.error = errorData;
      console.log("no data");
      this.loading = false;
    });
  }

  checkManegerialLogin(mobile,policyHolder){
    if(mobile !== 'NA' && mobile === localStorage.getItem('mobileNumber')) {
      localStorage.setItem('isManagerialLogin','true')
      this.isManagerialLogin = true
    }else{
      localStorage.setItem('isManagerialLogin','false')
      this.isManagerialLogin = false
    }
    if((!!localStorage.getItem('pamClientId') && localStorage.getItem('pamClientId').toLowerCase() === "738113".toLowerCase())
      || (!! localStorage.getItem('companyName') && localStorage.getItem('companyName').toLowerCase().trim() === "National Foundation for India-CSOs".toLowerCase().trim())) {
      localStorage.setItem('isManagerialLogin','false')
      this.isManagerialLogin = false
    }
  }
  routeToEndoView=(type)=>{
    let obj={
      type:type,
      policyNumber:this.policyNumber,
      endDate:this.endDate.split("T")[0],
      startDate:this.startDate.split("T")[0],
      productName : this.policyName ,
      cdNameId:this.cdNameId,
      clientId:this.clientId,
      insurerId:this.insurerId,
      sumInsured:this.sumInsured,
      mobileNumber:this.mobile,
      productId:this.productId,
      insurerCode:this.insurerCode,
      policyHolder:this.policyHolder,
      policyEmail:this.email,
      insurerName:this.insurer,
      policyEndDate:this.endDate,
      familyDefinition:this.familyDefinition
    }
    sessionStorage.setItem("policyDetailsEndorsement",JSON.stringify(obj))
      this.router.navigate(['/view-endorsements'])
  }

  routeToEngagementActivity=(typeOfPanel)=>{
    var policyId = localStorage.getItem("policyId");
    window.open(environment.pamUrl + "/Dashboard/clientEngagement?policyId="+policyId + " " +"type="+typeOfPanel, "_self")
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
  
}
